/**
 * ProctoringAlertBanner.jsx
 * Non-blocking alert banner shown during assessment for proctoring violations.
 * Fixed at top of screen and auto-dismissed by parent hook.
 */

import React from 'react';

function isCritical(message) {
  const text = String(message || '').toLowerCase();
  return text.includes('multiple faces') || text.includes('copy/paste');
}

export default function ProctoringAlertBanner({ message, onDismiss }) {
  if (!message) return null;

  const critical = isCritical(message);
  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[1200] px-4 py-3 transition-transform duration-300 ${
        critical ? 'bg-red-600/95' : 'bg-amber-500/95'
      }`}
    >
      {/* ADDED: unified warning banner for all assessment pages. */}
      <div className="mx-auto max-w-6xl flex items-center gap-3 text-white">
        <span className="text-base leading-none">{critical ? '!' : '*'}</span>
        <p className="text-sm md:text-base flex-1">{message}</p>
        <button
          type="button"
          onClick={onDismiss}
          className="rounded-md border border-white/35 px-2 py-1 text-xs hover:bg-white/10"
        >
          Close
        </button>
      </div>
    </div>
  );
}
